import React from 'react';
export function DiamondMark({
  className = ''
}: {
  className?: string;
}) {
  return <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true" data-id="element-8">
      <rect x="16" y="2" width="19.8" height="19.8" transform="rotate(45 16 2)" stroke="#FFFFFF" strokeOpacity="0.4" strokeWidth="1" fill="none" data-id="element-9" />
      <rect x="16" y="11" width="7.07" height="7.07" transform="rotate(45 16 11)" fill="#F5C518" data-id="element-10" />
    </svg>;
}